import * as yup from 'yup';
import { useMemo } from 'react';
import useTranslation from '../../../Hooks/useTranslation';

export default function useMedicalProcedureValidation() {
	const { t } = useTranslation();

	const validationSchema = useMemo(() => {
		return yup.object().shape({
			medicalProcedures: yup.array().of(
				yup.object().shape({
					medicalProcedure: yup.object().shape({
						label: yup
							.string()
							.typeError(
								t('validation.discourseCareClaimForm.medicalProcedure') ?? '',
							),
						value: yup
							.string()
							.typeError(
								t('validation.discourseCareClaimForm.medicalProcedure') ?? '',
							)
							.required('validation.discourseCareClaimForm.medicalProcedure'),
					}),
				}),
			),
		});
	}, [t]);

	return { validationSchema };
}
